import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Distributor } from '../../models/distributors/distributor';
import { DistributorService } from './distributor.service';

export const distributorResolver: ResolveFn<Distributor> = (route, state) => {
  const distributorService = inject(DistributorService)

  return distributorService.getDistributorById(Number(route.paramMap.get('id')))
};
